import ProfileMenuModal, { ProfileMenuModalProps } from './ProfileMenuModal'
import withInteractor from './ProfileMenuModal.interactor'
import withPresenter from './ProfileMenuModal.presenter'

export type { ProfileMenuModalProps }
export default withInteractor(withPresenter(ProfileMenuModal))
